module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step5-ES.bed5cd6d.png";